// App
import type { ReactNode } from 'react';
import React from 'react';
import cx from 'classnames';

// Misc / utils
import IconX from 'images/icons/x.min.svg';
import * as S from './styles';

interface PillProps {
  children: ReactNode;
  className?: string;
  filterKey: string;
  // eslint-disable-next-line no-unused-vars
  onItemClearClick: (key: string) => void;
}

const Pill: React.FC<PillProps> = ({ children, className, filterKey, onItemClearClick }) => {
  const handleRemoveFilterItemSelect = () => {
    onItemClearClick(filterKey);
  };

  return (
    <S.FilterPillContainer className={cx(className)} onClick={handleRemoveFilterItemSelect}>
      {children}
      <S.FilterPillIcon src={IconX} width="10px" height="10px" alt="Remove filter button icon" />
    </S.FilterPillContainer>
  );
};

export default Pill;
